import React from "react";
import "./style.scss";
import ReviewSkuList from "../../../components/Review/ReviewSkusList";

const ReviewSkuListPage = () => {
  return (
    <div className="review_page_wrapper">
      <ReviewSkuList />
    </div>
  );
};

export default ReviewSkuListPage;
